import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const ThemeContext = createContext(null);
const AKEY = "pgp_accent";

export const ACCENTS = {
  amber: { label: "Ambra", c400: "#fbbf24", c500: "#f59e0b", c600: "#d97706" },
  cyan: { label: "Ciano", c400: "#22d3ee", c500: "#06b6d4", c600: "#0891b2" },
  emerald: { label: "Smeraldo", c400: "#34d399", c500: "#10b981", c600: "#059669" },
  violet: { label: "Viola", c400: "#a78bfa", c500: "#8b5cf6", c600: "#7c3aed" },
  rose: { label: "Rosa", c400: "#fb7185", c500: "#f43f5e", c600: "#e11d48" },
  blue: { label: "Blu", c400: "#60a5fa", c500: "#3b82f6", c600: "#2563eb" },
};

// Tema unico: chiaro. La classe .light è forzata sul documento e non può essere rimossa.
function forceLight() {
  const el = document.documentElement;
  el.classList.remove("dark");
  el.classList.add("light");
}
function applyAccent(name) {
  const a = ACCENTS[name] || ACCENTS.amber;
  const el = document.documentElement;
  el.style.setProperty("--accent-400", a.c400);
  el.style.setProperty("--accent-500", a.c500);
  el.style.setProperty("--accent-600", a.c600);
}

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const [accent, setAccentState] = useState(() => localStorage.getItem(AKEY) || "amber");

  useEffect(() => { forceLight(); }, []);
  useEffect(() => { applyAccent(accent); }, [accent]);

  useEffect(() => {
    if (!user) return;
    if (user.accent && user.accent !== accent) { setAccentState(user.accent); localStorage.setItem(AKEY, user.accent); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const setAccent = async (name) => {
    setAccentState(name); localStorage.setItem(AKEY, name);
    if (user) { try { await api.patch("/me/accent", { accent: name }); } catch (e) { /* */ } }
  };

  return (
    <ThemeContext.Provider value={{ theme: "light", accent, setAccent, ACCENTS }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
